import React, { useContext, useMemo, useState } from "react"
import { Input, SegmentedControl } from "@mantine/core"
import debounce from "lodash.debounce"

import { Icon } from "@/components/Icon"

import { Options } from "@/components/TopNavigation/components/RegionSelector/Dropdown/Options/Options"
import { useStyles } from "@/components/TopNavigation/components/RegionSelector/Dropdown/Dropdown.styles"
import { TabValue } from "@/components/TopNavigation/components/RegionSelector/Dropdown/types"

const REGION_TYPES: { label: string; value: TabValue }[] = [
    { label: "Recent", value: "recent" as TabValue },
    { label: "All regions", value: "all-regions" },
    { label: "Custom", value: "custom" },
]

type DropdownProps = {
    onCancel: () => void
}

export const Dropdown = ({ onCancel }: DropdownProps) => {
    const { classes } = useStyles()
    const [activeType, setActiveType] = useState<TabValue>("recent")
    const [search, setSearch] = useState("")

    const debouncedSetSearch = useMemo(() => debounce(setSearch, 250), [])

    const { [activeType]: OptionsList } = {
        "all-regions": Options.Groups,
        recent: Options.Recent,
        custom: Options.Custom,
    }

    return (
        <>
            <div className={classes.inputWrapper}>
                <Input
                    className={classes.searchInput}
                    icon={<Icon icon="search" className={classes.searchIcon} />}
                    placeholder="Search a region"
                    type="search"
                    aria-label="Region"
                    onChange={(e) => debouncedSetSearch(e.target.value)}
                />
            </div>

            <SegmentedControl
                className={classes.regionTypes}
                data={REGION_TYPES}
                onChange={(regionType) => setActiveType(regionType as TabValue)}
                value={activeType}
            />

            <Options search={search}>
                <OptionsList />
            </Options>
        </>
    )
}
